<template>
  <div class="bodys" v-if="body_show">
    <div class="mclist_top clearfix">
      <ul>
        <li @click="buystatus=2" :class="buystatus==2?'buystatus':''">全部测评</li>
        <li @click="buystatus=0" :class="buystatus==0?'buystatus':''">专业测评</li>
        <li @click="buystatus=1" :class="buystatus==1?'buystatus':''">趣味测评</li>
      </ul>
    </div>
    <div class="mclist_main">
      <ul>
        <li v-for="(item,index) in list" :key="index" v-show="item.type==buystatus || buystatus == 2" class="clearfix">
          <a :href="parseQuery(item.url)" class="course clearfix">
            <img :src="item.show_img" class="img1" alt="" />
            <div class="course_fg">
              <h3>{{item.title}}</h3>
              <h4 class="text-ellipsis">{{item.sub_title}}</h4>
              <h5 v-if="item.is_buy==1">收费 {{item.price}} <span>|</span> {{item.num}}人已测</h5>
              <h5 v-else>{{item.is_free==1?'限时':''}}免费 <b v-if="item.is_free==1">{{item.price}}</b> <span> |</span> {{item.num}}人已测</h5>
            </div>
          </a>
          <img src="@a/list_0.png" class="img2" alt="" v-show="buystatus == 2 && item.type==1" />
          <img src="@a/list_1.png" class="img2" alt="" v-show="buystatus == 2 && item.type==0" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {
  Evaluation_list
} from "@/api/measurement"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        list: [],
        buystatus: 2
      };
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        Evaluation_list()
          .then(data => {
            this.list = data;
            this.body_show = true;
            this.$toast.clear();
          });
      },
      parseQuery(link) {
        if(this.$route.query.lead_sid) {
          let sep = link.includes('?') ? '&' : '?';
          return `${link}${sep}lead_sid=${this.$route.query.lead_sid}`;
        }

        return link;
      },
    },
    created() {
      this.pullData();
      shareCon("measurement_list", this);
    }
};
</script>
<style lang="scss" scoped>
.mclist_top {
  padding-top: 30px;
  text-align: center;
  background-color: #fff;
  ul li {
    color: #999;
    font-size: 28px;
    margin: 0 60px;
    padding-bottom: 24px;
    border-bottom: 4px solid #fff;
    display: inline-block;
  }
  .buystatus {
    border-bottom-color: #EB5032;
    color: #EB5032;
  }
}

.empry {
  margin-top: 287px;
  text-align: center;
  img {
    width: 180px;
  }
  p {
    margin-top: 30px;
    font-size: 26px;
    color: #999;
  }
  a {
    width: 170px;
    height: 66px;
    background: rgba(235, 80, 50, 1);
    border-radius: 33px;
    display: inline-block;
    font-size: 34px;
    color: #fff;
    line-height: 66px;
    margin-top: 50px;
  }
}

.mclist_main {
  padding: 0 30px;
  ul li {
    width: 690px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 20px;
    margin-top: 20px;
    position: relative;
    .course {
      display: block;
      position: relative;
      .course_fg {
        width: 400px;
        float: left;
        margin-left: 20px;
        h3 {
          color: #333;
          font-size: 28px;
        }
        h4 {
          color: #999;
          font-size: 24px;
        }
        h5 {
          color: #EB5032;
          font-size: 20px;
          margin-top: 55px;
          span {
            color: #ccc;
          }
          b {
            text-decoration: line-through;
            font-weight: normal;
          }
        }
      }
      img.img1 {
        width: 200px;
        float: left;
      }
    }
    img.img2 {
      position: absolute;
      right: 0;
      top: 0;
      width: 70px;
    }
  }
}
</style>
